var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collectionDocument)?_c('div',{staticClass:"home collection"},[(_vm.collectionDocument.blocks)?_c('blocks',{attrs:{"blocks":_vm.collectionDocument.blocks,"origin":_vm.ORIGIN.HOME,"entities":{ collection: _vm.collectionDocument },"is-home":"","is-on-top-of-page":""}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }